<template>
    <section class="payment-methods">
     <v-container>
        <v-subheader class="text-center  mt-1 mb-1 black--text">{{$t("userAccount.paymentMethods.paymentMeth")}}</v-subheader>
        <p class="text-caption mb-4">
         {{$t("userAccount.paymentMethods.paymentMethText")}}
        </p>
        <v-expansion-panels
         hover popout 
        >
        <v-expansion-panel
         v-for="(paymentMethod,index) in paymentMethods "
         :key="index"
        >
         <v-expansion-panel-header>
          {{paymentMethod.name}}
         </v-expansion-panel-header>
         <v-expansion-panel-content>
          {{paymentMethod.desc}}
          <v-btn block color="yellow" class="mt-2 darken-4" dark>save your payment method</v-btn>
         </v-expansion-panel-content>
        </v-expansion-panel>
        </v-expansion-panels>
     </v-container>
    </section>
</template>

<script>
export default {
    name:'userPymentMethods',
    data() {
        return {
            paymentMethods:[
                {
                    name:'pypale',
                    desc:'qjksjqnjksn',
                },
                {
                    name:'master card',
                    desc:'qjksjqnjksn',
                },
                {
                    name:'visa',
                    desc:'qjksjqnjksn',
                },
            ]
        }
    },
}
</script>